<template>
    <div class="layout">
        <!-- <NavbarMobile v-if="getIsMobile" />
        <Navbar v-else /> -->
        <MainContainer />
        <!-- <NavbarMenu v-if="getMobileMenuVisible" /> -->
    </div>
</template>

<script>
// import Navbar from './Navbar.vue'
// import NavbarMobile from './NavbarMobile.vue'
import MainContainer from './MainContainer.vue'
// import NavbarMenu from './NavbarMenu.vue'
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            //
        }
    },
    components: {
        // Navbar,
        // NavbarMobile,
        // NavbarMenu,
        MainContainer,
    },
    computed: {
        ...mapGetters('app', ['getIsMobile', 'getMobileMenuVisible']),
    },
    methods: {
        //
    },
}
</script>

<style lang="scss" scoped>
.layout {
    height: 100%;
}
</style>